var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRemoveUploadIcon = function SvgRemoveUploadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 1.00928C14.9655 1.00928 18.9909 5.03459 18.9909 10.0001C18.9909 14.9655 14.9655 18.9909 10.0001 18.9909C5.03459 18.9909 1.00928 14.9655 1.00928 10.0001C1.00928 5.03459 5.03459 1.00928 10.0001 1.00928ZM10.0002 2.25937C5.72505 2.25937 2.25937 5.72505 2.25937 10.0002C2.25937 14.2753 5.72505 17.741 10.0002 17.741C14.2753 17.741 17.741 14.2753 17.741 10.0002C17.741 5.72505 14.2753 2.25937 10.0002 2.25937ZM13.6133 10.5902C13.9725 10.5902 14.2637 10.299 14.2637 9.93982C14.2637 9.58063 13.9725 9.28945 13.6133 9.28945H6.3106C5.95141 9.28945 5.66023 9.58063 5.66023 9.93982C5.66023 10.299 5.95141 10.5902 6.3106 10.5902H13.6133Z",
    fill: "#B91036"
  })));
};
export default SvgRemoveUploadIcon;